import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faUserMd,
  faMapMarkerAlt,
  faCertificate,
  faGraduationCap,
  faLanguage,
  faStethoscope,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/DoctorSidebarCard.css";

const DoctorSidebarCard = ({ doctor }) => {
  const degrees =
    typeof doctor.degrees === "string"
      ? doctor.degrees.split(",")
      : doctor.degrees || [];

  const languages = doctor.languages_spoken?.join(", ") || "English";
  const subspecialties = doctor.subspecialties?.slice(0, 3).join(", ");

  return (
    <div className="doctor-sidebar-card">
      <div className="card-content">
        <h2>
          {doctor.rating || "0"} <FontAwesomeIcon icon={faStar} className="star-icon" /> / 5
        </h2>
        <p>{doctor.reviews?.length || 0} reviews</p>

        <hr />

        <p>
          <FontAwesomeIcon icon={faMapMarkerAlt} />{" "}
          {doctor.locations?.[0]?.city || "Unknown"},{" "}
          {doctor.locations?.[0]?.country || "Country"}{" "}
          {doctor.locations?.length > 1 ? `(+${doctor.locations.length - 1} more)` : ""}
        </p>

        <p>
          <FontAwesomeIcon icon={faCertificate} />{" "}
          {doctor.registration?.body || "Unregistered"} —{" "}
          <strong>{doctor.registration?.number || "N/A"}</strong>
        </p>

        <p>
          <FontAwesomeIcon icon={faGraduationCap} />{" "}
          {degrees.slice(0, 2).join(", ")}
        </p>

        <p>
          <FontAwesomeIcon icon={faLanguage} /> {languages}
        </p>

        <p>
          <FontAwesomeIcon icon={faStethoscope} /> {subspecialties || "General"}
        </p>

        <hr />

        <small style={{ color: "gray" }}>
          This doctor is listed on Virtual Triage. Contact options will be
          available soon.
        </small>
      </div>
    </div>
  );
};

export default DoctorSidebarCard;
